/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_Extended_AccessInputs */

const fr_membership_section_extended_access = /** @type {(inputs: Membership_Section_Extended_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès 6h-23h`)
};

/**

* @param {Membership_Section_Extended_AccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_extended_access = /** @type {((inputs?: Membership_Section_Extended_AccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_Extended_AccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_extended_access(inputs)
});